"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extend_1 = __importDefault(require("extend"));
var TrackerUtil_1 = __importDefault(require("./TrackerUtil"));
var BasicTrackerAbstractImpl_1 = __importDefault(require("./BasicTrackerAbstractImpl"));
;
var GoogleAnalytics = /** @class */ (function (_super) {
    __extends(GoogleAnalytics, _super);
    function GoogleAnalytics(options) {
        var _this = _super.call(this, options) || this;
        _this.platformName = GoogleAnalytics.platformName;
        _this.isInterceptorSetup = false;
        // Setup interceptor - So we can notify observers.
        _this.setupInterceptor();
        // Log information
        _this.getLogger().debug(_this.platformName + " instance initialized.", "Options: ", options);
        return _this;
    }
    /**
     * @public
     * Returns an instance of this class for the `options.trackerName`. Name is typically
     * not specified and will return the standard image. Name is only used when multiple
     * instances of Google Anlaytics is installed on a website or app.
     * If an instance of this class already exists for a `name` that instance will be reutrned
     * and the other options of the property passed will be ignored.
     */
    GoogleAnalytics.getInstance = function (options) {
        options = extend_1.default(true, {}, GoogleAnalytics.defaultOptions, options);
        var tracker = TrackerUtil_1.default.getInstance(options, GoogleAnalytics.instances, function (options) {
            return new GoogleAnalytics(options);
        });
        return tracker;
    };
    /**
     * @public
     */
    GoogleAnalytics.prototype.trackPageview = function (pagePath, title) {
        pagePath = TrackerUtil_1.default.pagePathCleanup(pagePath);
        var fieldsObject = this.buildBaseFieldsObject("pageview");
        fieldsObject.page = pagePath;
        if (title !== undefined) {
            fieldsObject.title = title;
        }
        this.getPlatformInstance()(this.getSendCommand(), fieldsObject);
        // Log
        this.getLogger().debug("GoogleAnalytics.trackPageview:", fieldsObject);
    };
    /**
     * @public
     */
    GoogleAnalytics.prototype.trackEvent = function (category, action, label, value, nonInteraction) {
        var fieldsObject = this.buildBaseFieldsObject("event");
        fieldsObject.eventCategory = category;
        fieldsObject.eventAction = TrackerUtil_1.default.eventActionToString(action);
        if (label !== undefined && label !== null) {
            fieldsObject.eventLabel = TrackerUtil_1.default.eventLabelToString(label);
        }
        if (value !== undefined && value !== null) {
            fieldsObject.eventValue = value;
        }
        if (nonInteraction !== undefined && nonInteraction !== null) {
            fieldsObject.nonInteraction = nonInteraction;
        }
        this.getPlatformInstance()(this.getSendCommand(), fieldsObject);
        // Log
        this.getLogger().debug("GoogleAnalytics.trackEvent:", fieldsObject);
    };
    /**
     * @private
     * Creates the send name while taking the tracker name into account, if there is one.
     */
    GoogleAnalytics.prototype.getSendCommand = function () {
        var trackerName = this.getTrackerName();
        if (trackerName === null || trackerName === "t0") {
            return "send";
        }
        return trackerName + ".send";
    };
    /**
     * @private
     */
    GoogleAnalytics.prototype.buildBaseFieldsObject = function (hitType) {
        var fieldsObject = {
            plaudit_hitOrigin: "internal",
            hitType: hitType
        };
        return fieldsObject;
    };
    /**
     * @private
     */
    GoogleAnalytics.prototype.setupInterceptor = function () {
        var _this = this;
        if (this.isInterceptorSetup === true) {
            return;
        }
        // Get the tracker
        this.getPlatformInstance()(function (tracker) {
            var ga = _this.getPlatformInstance();
            var trackerName = _this.getTrackerName();
            if (trackerName !== null) {
                tracker = ga.getByName(trackerName);
            }
            var trackerOriginalSendHitTask = tracker.get("sendHitTask");
            tracker.set("sendHitTask", function (model) {
                _this.notifyObservers(model);
                if (trackerOriginalSendHitTask !== undefined && trackerOriginalSendHitTask !== null) {
                    trackerOriginalSendHitTask(model);
                }
            });
        });
        // Record that hit interceptor is setup (technically it may not be since the ga() callback above is aysnc, but close enough since we don't want to setup multiple instances.
        this.isInterceptorSetup = true;
    };
    /**
     * Observrs will be notified of pageview and events
     */
    GoogleAnalytics.prototype.addObserver = function (observer) {
        if (this.observers === undefined) {
            this.observers = new Set();
        }
        this.observers.add(observer);
    };
    GoogleAnalytics.prototype.removeObserver = function (observer) {
        if (this.observers === undefined) {
            return;
        }
        this.observers.delete(observer);
    };
    GoogleAnalytics.prototype.notifyObservers = function (model) {
        var _this = this;
        if (this.observers === undefined) {
            return;
        }
        this.observers.forEach(function (observer) {
            observer.update(_this, model);
        });
        this.getLogger().debug("GoogleAnalytics.notifyObservers:", model, this.observers);
    };
    GoogleAnalytics.platformName = "GoogleAnalytics";
    GoogleAnalytics.instances = new Map();
    GoogleAnalytics.defaultOptions = {
        globalKeyForPlatform: "ga" // TODO: Should we use window.GoogleAnalyticsObject to override this? That seems to store the name which coud be something other than GA. See the standard Google Analytics' analytics.js integration code: https://developers.google.com/analytics/devguides/collection/analyticsjs
    };
    return GoogleAnalytics;
}(BasicTrackerAbstractImpl_1.default));
exports.default = GoogleAnalytics;
